import { Typography } from '@mui/material';
import { clsx } from 'clsx';
import React, { memo, useMemo } from 'react';

import { BarChart } from '~/components/BarChart';
import { GetCompanyInferenceResponse } from '~/services/rtkQuery/company/types';

import styles from './styles.module.scss';

const X_AXIS_DOMAIN = [1, 5];
const Y_AXIS_DOMAIN = [0, 0.12];

interface Props {
  rating: number;
  data: GetCompanyInferenceResponse['result']['data']['supporting_graphs']['companies_scores'];
  className?: string;
}

const Component: React.FC<Props> = ({ rating, data, className }) => {
  const barChartData = useMemo(() => {
    return data.bins.map((bin, index) => ({ x: bin, y: data.weights[index] }));
  }, [data.bins, data.weights]);

  const lines = useMemo(() => {
    return [
      { x: rating, y: Y_AXIS_DOMAIN[1] - 0.01, type: 'error' as const },
      { x: data.mean, y: Y_AXIS_DOMAIN[1] - 0.01, type: 'danger' as const },
    ];
  }, [data.mean, rating]);

  return (
    <div className={clsx(styles.container, className)}>
      <Typography color="var(--text-3-color)" mb="14px" variant="subtitle1">
        Co-investment Score for the Company
      </Typography>
      <BarChart
        data={barChartData}
        leftBottomLabel={`Company = ${rating.toFixed(2)}`}
        leftTopLabel={`Mean = ${data.mean.toFixed(2)}`}
        lines={lines}
        xAxisDomain={X_AXIS_DOMAIN}
        xAxisTickCount={9}
        yAxisDomain={Y_AXIS_DOMAIN}
        yAxisTickCount={7}
      />
    </div>
  );
};

export const CoInvestmentScore = memo(Component);
